import { PackagingDetailDto, PackagingEditDto } from './packaging';

export const mapPackagingDetailToEdit = (
  dto: PackagingDetailDto
): PackagingEditDto => ({
  id: dto.id,
  no: dto.no,
  name: dto.name,
  description: dto.description,
  weight: dto.weight,
  active: dto.active
});
